module.exports = __webpack_public_path__ + "static/img/vote_B.5fefee4.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/vote/vote_B.png
// module id = HVUL
// module chunks = 1